import { Controller } from "@hotwired/stimulus"

// Client-side tab toggle for the dashboard document previews. All three panels
// are server-rendered; this just shows the active one, styles the active tab's
// underline, updates the big heading, and remembers the last tab in localStorage.
export default class extends Controller {
  static targets = ["tab", "panel", "heading"]
  static values  = { storageKey: { type: String, default: "dashboard-docs-tab" } }

  connect() {
    let saved = null
    try { saved = localStorage.getItem(this.storageKeyValue) } catch (_) {}
    const known = this.tabTargets.some((t) => t.dataset.tab === saved)
    const initial = known ? saved : this.tabTargets[0]?.dataset.tab
    if (initial) this.activate(initial)
  }

  select(event) {
    const tab = event.currentTarget.dataset.tab
    this.activate(tab)
    try { localStorage.setItem(this.storageKeyValue, tab) } catch (_) {}
  }

  activate(tab) {
    this.tabTargets.forEach((t) => {
      const on = t.dataset.tab === tab
      t.classList.toggle("text-on-surface", on)
      t.classList.toggle("border-primary", on)
      t.classList.toggle("text-on-surface-variant", !on)
      t.classList.toggle("border-transparent", !on)
      t.setAttribute("aria-selected", on ? "true" : "false")
    })
    this.panelTargets.forEach((p) => p.classList.toggle("hidden", p.dataset.tab !== tab))
    if (this.hasHeadingTarget) {
      const active = this.tabTargets.find((t) => t.dataset.tab === tab)
      if (active) this.headingTarget.textContent = active.dataset.label || active.textContent.trim()
    }
  }
}
